<template>
  <div class="er-code-wrapper">
    <img :src="this.$props.qrCode" alt="" class="er-code-img" crossorigin="anonymous"/>
    <div class="rg-wrapper">
      <p>长按识别二维码</p>
      <p>关注《蓝思原版分级阅读》</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PublicErCode",
    props: {
      qrCode: {
        type: String,
        default: '',
      }
    },
    data() {
      return {
        erCode: 'http://oss-leveledreading.oss-cn-beijing.aliyuncs.com/weixin/qrcode.jpg'
      }
    },
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .er-code-wrapper {
    text-align: center;
    font-size: 10px;
  }
  .er-code-img {
    padding: 10px;
    width: 60px;
    height: 60px;
  }
</style>



// WEBPACK FOOTER //
// app/components/pulicErCode/PublicErCode.vue